The details of the position associated with the verification request.
